import { printOffer } from "./prints";
import { fetchCrownpeakUrlDetails } from "./share";

interface OfferSelectors {
    titleSelector: string;
    descriptionSelector: string;
    expirySelector: string;
    disclaimerSelector: string;
    couponCodeInputSelector: string;
}
export function attachEventListenerForClaim(sectionSelector: any, buttonSelector: any, liItem: any, commonSelectors: OfferSelectors ) {
    const claimOfferButtons = document.querySelectorAll(`${sectionSelector} ${buttonSelector}`);
    if (claimOfferButtons?.length === 0) return;

    claimOfferButtons.forEach((button,index) => {
        // Check if the href attribute is not empty
        if (button?.getAttribute('href') !== '' && button?.getAttribute('href') !== '#') {
            // Attach the event listener
            button?.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent the default action 
                const target = event.target as HTMLElement;
                // Check if the target is the claim button
                if (target?.classList?.contains('secondary-btn')) {
                    const href = (target as HTMLAnchorElement).href;
                    let parentDom;
                    if (sectionSelector === '.sp-offers-section.coupons-eight' || sectionSelector === '.offers-block-section' || sectionSelector === '.offers-block-section.dynamic-offer-teaser-component') {
                        parentDom = target?.closest(liItem) as HTMLElement;
                        if (parentDom) {
                            setOffersInSessionCommon(sectionSelector,
                                parentDom,
                                href,
                                commonSelectors 
                            )
                        }
                    }
                      
                }
            });
        }
        else if ((sectionSelector === '.offers-block-section' || sectionSelector === '.offers-block-section.dynamic-offer-teaser-component') && !(button?.getAttribute('href') !== '' && button?.getAttribute('href') !== '#')) {
            button.addEventListener('click', (e) => {
                e.preventDefault();  // Prevent the default click behavior
                printOffer(e,index);  // Assuming printOffer is the function that handles printing
            });
        }
        // Attach the print functionality if the anchor is inside a `.print-offer-link`
        const printOfferLink = button.closest('.offers-block-item')?.querySelector('.print-offer-link a');
        if (printOfferLink) {
            printOfferLink.addEventListener('click', (e) => {
                e.preventDefault(); // Prevent default anchor action
                printOffer(e, index); // Assuming printOffer is the function that handles printing
            });
        }
        
    });
}


function setOffersInSessionCommon(
    sectionSelector: any,
    targetElement: HTMLElement,
    href: string | null,
    commonSelectors: OfferSelectors 
) {
    const obj = {
        'title': '',
        'description': '',
        'couponexpirydate': '',
        'longdescription': '',
        'couponcode': '',
        'servicemodifier': [] as string[]
    };

    // Info from offer
    obj.title = targetElement.querySelector(commonSelectors.titleSelector)?.textContent ?? '';
    obj.description = targetElement.querySelector(commonSelectors.descriptionSelector)?.textContent ?? '';
    obj.couponexpirydate = targetElement.querySelector(commonSelectors.expirySelector)?.textContent?.replace('Expires: ', '') ?? '';

    //Long description from the disclaimer text
    const firstTxt = targetElement.querySelector(`${commonSelectors.disclaimerSelector} p`)?.textContent ?? '';
    const secondTxt = targetElement.querySelector(`${commonSelectors.disclaimerSelector} p a`)?.textContent ?? '';  // Assuming you want to append the link text too
    obj.longdescription = `${firstTxt} ${secondTxt}`;
    const serviceTyleValues = targetElement.querySelector<HTMLInputElement>('input[type="hidden"][servicetype]')?.getAttribute('servicetype') ?? '';
    if(serviceTyleValues){
        obj.servicemodifier = serviceTyleValues.split(',');
    }

    //if its coupon11
    if (sectionSelector === '.offers-block-section' || sectionSelector === '.offers-block-section.dynamic-offer-teaser-component') {
        const firstTxt = targetElement.querySelector(`${commonSelectors.disclaimerSelector}`)?.textContent ?? '';
        obj.longdescription = `${firstTxt}`;
    }
    // coupon code from the hidden field
    const couponCodeInput = targetElement.querySelector(commonSelectors.couponCodeInputSelector) as HTMLInputElement;

    if (sectionSelector === '.offers-block-section.dynamic-offer-teaser-component') {
        const index = Array.from(targetElement.parentElement?.children ?? []).indexOf(targetElement); // Get the index of the current li item

        // Only try to fetch coupon code if the couponCodeInputSelector exists
        if (commonSelectors.couponCodeInputSelector) {
            const couponCodeSpan = targetElement.querySelector(`${commonSelectors.couponCodeInputSelector}${index}`);
            if (couponCodeSpan) {
                obj.couponcode = couponCodeSpan.textContent ?? ''; // Set coupon code if found
            }
            else {
                console.log("No Coupon code found");
            }
        }
    } else if (couponCodeInput) {
        obj.couponcode = couponCodeInput.value;
    }
    else {
        console.log("No Coupon code found");
    }
    storeOfferAndRedirect(obj, href);
}

function storeOfferAndRedirect(offer: Record<string, any>, href: string | null) {
    sessionStorage.setItem('offerDetails', JSON.stringify(offer));
    if (href) {
        globalThis.location.href = href;
    }
}
 export async function getOfferTeaserPath(): Promise<string | null>  {
       const url = globalThis.location.origin;
        const dbaName: string | null = localStorage.getItem('dbaName');
        let pathSegments = [];

        if (dbaName) {
            const brandData = localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null;
            if (brandData?.include_statename) {
                let weblocationInfo = (globalThis as any)?.crownpeakWeblocationsByIdDetail;
                if (weblocationInfo) {
                    const stateName = weblocationInfo?.stateName;
                    pathSegments.push('specialofferteaserdata', dbaName, stateName);
                    return `${url}/${pathSegments.join('/')}`;
                }else{
                    await fetchCrownpeakUrlDetails();
                    weblocationInfo = (globalThis as any)?.crownpeakWeblocationsByIdDetail;
                    if (weblocationInfo) {
                        const stateName = weblocationInfo?.stateName;
                        pathSegments.push('specialofferteaserdata', dbaName, stateName);
                        return `${url}/${pathSegments.join('/')}`;
                    }else{
                        pathSegments.push('specialofferteaserdata', dbaName);
                        return `${url}/${pathSegments.join('/')}`;
                    }
                }
            
            }
            pathSegments.push('specialofferteaserdata', dbaName);
            return `${url}/${pathSegments.join('/')}`;
        }

        return null;
    }

export function attachEventListenerForHeroBannerClaim(): void {
    const claimbutton = document.querySelector<HTMLAnchorElement>('section.hero-banner .hero-coupon-cta-button');
    if (!claimbutton) return;

    const href = claimbutton.getAttribute('href');
    if (href === '' || href === '#') return;

    claimbutton.addEventListener('click', (event) => {
        event.preventDefault();
        const contentWrap = claimbutton.closest('.hero-coupon-content') as HTMLElement;
        const ctaWrap = claimbutton.closest('.hero-coupon-cta-wrap') as HTMLElement;
        const couponCodeSpan = ctaWrap?.querySelector('#hero-banner-Offer-cpn-code') as HTMLSpanElement;
        const couponCode = couponCodeSpan?.textContent?.trim() ?? '';

        const offer = {
            title: contentWrap?.querySelector('.hero-coupon-offer')?.textContent?.trim() ?? '',
            description: contentWrap?.querySelector('.hero-coupon-desc')?.textContent?.trim() ?? '',
            couponexpirydate: contentWrap?.querySelector('.hero-coupon-expires')?.textContent?.replace('Expires: ', '').trim() ?? '',
            longdescription: contentWrap?.querySelector('.hero-coupon-footer')?.textContent?.trim() ?? '',
            couponcode: couponCode,
            servicemodifier: [] as string[]
        };

        storeOfferAndRedirect(offer, claimbutton.href);
    });
}
